import { getHashValue } from 'src/functions';
import { Platform } from 'quasar';
import { BrazePluginV2 } from 'capacitor-plugin-braze-v2';

import { Geolocation } from '@capacitor/geolocation';
//import type {  BrazePluginPlugin  } from 'capacitor-plugin-braze';

const brazeService = {
  register() {
    if ( Platform.is.capacitor && Platform.is.ios && BrazePluginV2)  {
      return BrazePluginV2.register();
    }
  },
  locationPermission() {
    if ( Platform.is.capacitor && Platform.is.ios && BrazePluginV2)  {
      return BrazePluginV2.locationPermission();
    }
  },
  async requestLocationPermission() {
    if(Platform.is.capacitor && Platform.is.android) {
      try {
        // Check current permission status
        const permission = await Geolocation.checkPermissions();

        if (permission.location === 'granted') {
          console.log('Location already granted');
          
          BrazePluginV2.requestLocationInitialization();

          return;
        }

        // Request permission (shows native prompt)
        const result = await Geolocation.requestPermissions({
          permissions: ['location']   // or ['coarseLocation'] if you only need approximate
        });

        if (result.location === 'granted') {
          console.log('User granted location permission');

          BrazePluginV2.requestLocationInitialization();
          
        } else {
          console.log('User denied location permission');
          // Optionally show a custom message explaining why you need location
        }
      } catch (error) {
        console.error('Error requesting location permission:', error);
      }
    }
  },
//   sendCampaign(data) {
//     // Decommission Braze Campaign
//     return new Promise((resolve, reject) => {
//       resolve();
//     });
//   },
  identify(email:string) {
    getHashValue(email).then((hashedUserId) => {
      if ( Platform.is.nativeMobile && ( BrazePluginV2) ) {
        if (BrazePluginV2) {
            if(Platform.is.ios) {
                BrazePluginV2.addListener('didReceiveRemoteNotification', (val) => {
                    window.alert(JSON.stringify(val));
                });
            }

            BrazePluginV2.changeUser({ value: hashedUserId });
            BrazePluginV2.setEmail({ value: email });
        }
      }
    });
  }
};

export default brazeService;